import { Component, Inject, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MonthlyReport, MonthlyReportIndexStatus } from '../../../../models/monthly-report.model';
import { MonthlyReportService } from '../../../../services/monthly-report.service';
import { DecimalInputComponent } from '../../../common/decimal-input.component';
import { FormsModule } from '@angular/forms';
import { blankOpen, getPool } from '../../../../misc/functions';
import { AdminSearchUserComponent } from '../../search-user/admin-search-user.component';
import { AdminUser, AdminUsersService } from '../../../../services/admin-users.service';
import { CurrencyTypes, PoolTypeMap } from '../../../../models/weekly-report.model';

interface DialogData {
  ad: number,
  isRebuildMode: boolean
};

@Component({
  standalone: true,
  selector: 'app-report-edit-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    DecimalInputComponent,
    FormsModule,
    AdminSearchUserComponent
  ],
  templateUrl: './admin-monthly-report-create.dialog.component.html',
})
export class AdminMonthlyReportCreateDialogComponent {

  saving = false;

  getPool = getPool;
  PoolTypeMap = PoolTypeMap;
  CurrencyTypes = CurrencyTypes;

  ad: number;
  user!: AdminUser;
  report: any = {};

  isRebuildMode = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
    private dialogRef: MatDialogRef<AdminMonthlyReportCreateDialogComponent, MonthlyReport | undefined>,
    private fb: FormBuilder,
    private monthlyService: MonthlyReportService,
    public adminUsersService: AdminUsersService
  ) {
    this.ad = this.dialogData.ad;
    this.isRebuildMode = this.dialogData.isRebuildMode;

    const y = this.ad.toString().substring(0, 4);
    const m = this.ad.toString().substring(4, 6);
    const period = `${y}-${m}-01`;

    this.report.period = period;
    this.report.enroll = period;
    this.calcChg();
  }

  onCancel(): void {
    this.dialogRef.close(); // 何も返さない = 親側では何もしない
  }

  onPoolSelect(e: MatSelectChange) {
    console.log(e.value);
    this.report.pool = e.value.pool;
    this.report.hdc = e.value.hdc;
    this.report.monthly_management_fee = e.value.mng;
    this.report.res_b = e.value.res_b;
    this.calcChg();
  }

  onUserSelect(e: AdminUser) {
    this.user = e;
    this.report.login_user_id = this.user.login;
    this.report.user_name = this.user.name;
  }

  calcChg() {
    const [y, m] = this.report.enroll.split('-').map(Number);
    if (!y || !m) {
      this.report.chg = undefined;
    }

    const months = Math.max(0, (this.report.res_b | 0) - 1);
    const end = new Date(y, (m - 1) + months + 1, 0); // 月末

    const yyyy = end.getFullYear();
    const mm = String(end.getMonth() + 1).padStart(2, '0');
    const dd = String(end.getDate()).padStart(2, '0');

    this.report.chg = `${yyyy}-${mm}-${dd}`;
  }

  get isValid() {
    return this.user && ['nyukin', 'cur', 'pool', 'hdc', 'enroll', 'res_b', 'chg'].every(x => this.report[x] && this.report[x].toString() !== '') &&
      (!this.report['flg'] || (this.report['flg'] === 'JAC' && this.report['cmm']?.length > 0));
  }

  onSave(): void {
    this.saving = true;
    // ★ API で更新
    this.monthlyService.create(this.report, this.ad, this.isRebuildMode).subscribe({
      next: (created: MonthlyReport) => {
        this.saving = false;
        // ★ 更新後の行データを親へ返す
        this.dialogRef.close(created);

        // 再構築モードなら当人の履歴画面を表示
        if (this.isRebuildMode) {
          this.adminUsersService.searchUsers(created.login_user_id, '', '').subscribe(res => {
            const users = this.adminUsersService.parseData(res);
            blankOpen(undefined, `/client/monthlyReport?uid=${users[0].id}`);
          });
        }

      },
      error: (err: any) => {
        console.error(err);
        this.saving = false;
        // TODO: Snackbar などでエラー表示（既に共通化済ならそこで）
      },
    });
  }

  get isPoolValid() {
    return !!this.report.pool;
  }

  get isCurValid() {
    return !!this.report.cur;
  }

  get isNyukinValid() {
    return !!this.report.nyukin;
  }

  get isHdcValid() {
    return !!this.report.hdc;
  }

  get isFlgValid() {
    return !this.report.flg || this.report.flg === 'JAC';
  }

  get isCmmValid() {
    // JAC なのにカラだと false
    if (this.report.flg === 'JAC' && !this.report.cmm) return false;
    return true;
  }
}
